module.exports = __webpack_public_path__ + "static/img/m_name.972a760.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/bz/m_name.png
// module id = 9tM7
// module chunks = 7